import type { EvidenceRole, LibraryStatus } from '../../request/evidence-library/evidenceLibraryRequests.ts';

export const ROLE_LABELS: Record<EvidenceRole, string> = {
  population: 'Population',
  ipe_proof: 'IPE proof',
  evidence: 'Evidence',
  supporting: 'Supporting',
};

export const ROLE_PILL: Record<EvidenceRole, string> = {
  population: 'bg-blue-50 text-blue-700 border-blue-200',
  ipe_proof: 'bg-purple-50 text-purple-700 border-purple-200',
  evidence: 'bg-green-50 text-green-700 border-green-200',
  supporting: 'bg-gray-100 text-gray-700 border-gray-200',
};

export const ROLE_ORDER: EvidenceRole[] = ['evidence', 'population', 'ipe_proof', 'supporting'];

export const STATUS_LABELS: Record<LibraryStatus, string> = {
  unclassified: 'Unclassified',
  classified: 'Classified',
  used: 'Used in a run',
};

export const STATUS_PILL: Record<LibraryStatus, string> = {
  unclassified: 'bg-amber-50 text-amber-700 border-amber-200',
  classified: 'bg-sky-50 text-sky-700 border-sky-200',
  used: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

/** Roles a population/IPE step may pick: the server rejects other file types for them. */
export function roleAllowedFor(role: EvidenceRole, filename: string, populationExtensions: string[]): boolean {
  if (role !== 'population' && role !== 'ipe_proof') return true;
  const i = filename.lastIndexOf('.');
  const ext = i > 0 ? filename.slice(i).toLowerCase() : '';
  return populationExtensions.includes(ext);
}
